import { render, staticRenderFns } from "./ResearchByoglSection.vue?vue&type=template&id=72e2d92a&scoped=true"
import script from "./ResearchByoglSection.vue?vue&type=script&lang=js"
export * from "./ResearchByoglSection.vue?vue&type=script&lang=js"
import style0 from "./ResearchByoglSection.vue?vue&type=style&index=0&id=72e2d92a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e2d92a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e2d92a')) {
      api.createRecord('72e2d92a', component.options)
    } else {
      api.reload('72e2d92a', component.options)
    }
    module.hot.accept("./ResearchByoglSection.vue?vue&type=template&id=72e2d92a&scoped=true", function () {
      api.rerender('72e2d92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchByoglSection.vue"
export default component.exports